import Course from 'src/model/Course';
import courseDatabaseMap from 'src/resource/course/CourseDatabaseMap';

export default class CourseRetriever {
  // Get a single course by courseId.
  static async getCourse(courseId?: string): Promise<Course> {
    if (courseId === undefined) {
      throw Error('courseId undefined.');
    }
    const course: Course | undefined = courseDatabaseMap.get(courseId);
    if (course === undefined) {
      throw Error('Course not found.');
    }
    return course;
  }
}
